import { render, staticRenderFns } from "./SeguroMovilidadPersonal.vue?vue&type=template&id=5424b4c0&scoped=true&"
import script from "./SeguroMovilidadPersonal.vue?vue&type=script&lang=js&"
export * from "./SeguroMovilidadPersonal.vue?vue&type=script&lang=js&"
import style0 from "./SeguroMovilidadPersonal.vue?vue&type=style&index=0&id=5424b4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424b4c0",
  null
  
)

export default component.exports